export default [{
	titulo: 'Lei Paulo Gustavo',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/lei-paulo-gustavo',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]